<template>
  <div class="page">
    <div class="list-view">
      <ud-empty-row />
      <p class="title">装修消防安全承诺书</p>
      <ud-empty-row />
      <p class="info">为确保________花园____栋____单元______号房装修工程施工期间的消防安全，遵照深圳市人民政府的有关规定，实行防火责任制，现绿景_________物业服务中心要求业主/装修公司签定本承诺书，承诺要点如下：</p>
      <p class="info">1.依据装修设计方案，接受物业服务中心对本装修工程进行监督。</p>
      <p class="info">2.如物业服务中心发现施工有不安全的因素，有权下令改正或下令停工直至不安全因素消除为止。</p>
      <p class="info">3.负责上述单元施工期间消防安全责任，保证不发生火灾等安全事故。</p>
      <p class="info">4.设立现场安全负责人，向物业服务中心解释消防安全工作，并对施工安全负责。</p>
      <p class="info">5.用电、动火前应得到物业服务中心批准后方可使用。</p>
      <p class="info">6.进行动火工作前，应向物业服务中心申办动火证，操作应由有焊工证人员执行，严禁违章操作。</p>
      <p class="info">7.装修现场禁止吸烟，并保证消防设备、设施完好，并不受遮挡。</p>
      <p class="info">8.施工区域应配备足够消防设备，四公斤ABC干粉手提灭火器数量不少于每一百平方米两具。</p>
      <p class="info">9.当发生消防事故时应及时处理，同时报告物业服务中心，事后书面报告事故原因，并保护好现场，配合调查。</p>
      <p class="info">10.施工垃圾应及时清理，尤其是刨花锯沫或易燃垃圾。施工堆料不得阻塞消防通道，严禁遮挡、损坏、挪用消防设备。</p>
      <p class="info">11.对施工人员进行安全教育，服从物业服务中心工作人员监督检查，并制定安全制度。</p>
      <p class="info">本消防安全承诺书的有效日期：从签发《装修许可证》开始生效之日至工程竣工验收合格之日。</p>
    </div>
  </div>
</template>

<script>
import UdEmptyRow from '@/components/ud-empty-row'

export default {
  components: {
    UdEmptyRow
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 24px;
  box-sizing: border-box;
}

.list-view {
  flex: 1;
  @include relative;
}

.title {
  @include text(28px);
  text-align: center;
}

.info {
  margin-bottom: 12px;
  @include text(22px);
  line-height: 1.2;
  @extend .flex-row;
  justify-content: space-between;
}
</style>